export default __webpack_public_path__ + "static/media/twitter.89aeb7db.svg";